import { Box, Toolbar } from "@mui/material"
import { ApiReferenceReact } from "@scalar/api-reference-react"
import "@scalar/api-reference-react/style.css"
import AppBarComponent from "../components/AppBarComponent"

function ApiDocsPage() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBarComponent />
      <Toolbar />
      <Box
        sx={{
          flexGrow: 1,
          height: "calc(100vh - 64px)",
        }}
      >
        <ApiReferenceReact
          configuration={{
            baseServerURL: import.meta.env.VITE_API_URL,
            url: "/api-docs/openapi.yml",
            authentication: {
              preferredSecurityScheme: "apiKeyHeader",
              securitySchemes: {
                apiKeyHeader: {
                  name: "X-MM-Service-Api-Key",
                  in: "header",
                },
              },
            },
            persistAuth: true,
            showDeveloperTools: "never",
          }}
        />
      </Box>
    </Box>
  )
}

export default ApiDocsPage
